import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  variants: null,
  variant: null,
  questionVariants: null,
};

// getters
export const getters = {
  variants: state => state.variants,
  variant: state => state.variant,
  questionVariants: state => state.questionVariants,
};

// mutations
export const mutations = {

  [types.FETCH_VARIANTS_SUCCESS] (state, { variants }) {
    state.variants = variants
  },

  [types.FETCH_QUESTION_VARIANTS_SUCCESS] (state, { questionId, variants }) {
    if (!state.questionVariants) {
      state.questionVariants = [];
    }
    state.questionVariants[questionId] = variants
  },

  [types.FETCH_VARIANTS_FAILURE] (state) {
    state.variants = null
  },

  [types.FETCH_QUESTION_VARIANTS_FAILURE] (state, { questionId }) {
    state.questionVariants[questionId] = null
  },

  [types.FETCH_ONE_VARIANT_SUCCESS] (state, { variant }) {
    state.variant = variant
  },

  [types.FETCH_ONE_VARIANT_FAILURE] (state) {
    state.variant = null
  },

  [types.CLEAR_VARIANT] (state) {
    state.variant = null
  },

  [types.ADD_VARIANT_SUCCESS] (state, { variant }) {
    if (state.variants) {
      state.variants.push(variant)
    } else {
      state.variants = [
        variant
      ]
    }
  },

  [types.REMOVE_VARIANT_SUCCESS] (state, { variantId }) {
    if (state.variants) {
      state.variants.splice(state.variants.findIndex(el => el.id === variantId), 1);
    } else {
      state.variants = null
    }
  },

  [types.UPDATE_VARIANT_SUCCESS] (state, { variant }) {

    let index = state.variants.findIndex(el => el.id === variant.id);

    if (index !== -1) {
      state.variants[index] = variant;
    }
  },

  [types.ADD_VARIANT_FAILURE] (state, { variant }) {
    state.variants = null
  },

  [types.REMOVE_VARIANT_FAILURE] (state, { variant }) {},
};

// actions
export const actions = {

  async fetchVariants ({ commit }, { questionId }) {
    try {
      const { data } = await axios.get('/api/questions/' + questionId + '/variants');

      commit(types.FETCH_VARIANTS_SUCCESS, { variants: data })
    } catch (e) {
      commit(types.FETCH_VARIANTS_FAILURE)
    }
  },

  async fetchFullVariants ({ commit }, { questionId }) {
    try {
      const { data } = await axios.get('/api/admin/questions/' + questionId + '/variants');

      commit(types.FETCH_VARIANTS_SUCCESS, { variants: data })
    } catch (e) {
      commit(types.FETCH_VARIANTS_FAILURE)
    }
  },

  clearVariant () {
    commit(types.CLEAR_VARIANT);
  },

  async fetchVariant ({ commit }, { questionId, id }) {
    try {
      const { data } = await axios.get('/api/variants/' + id);

      commit(types.FETCH_ONE_VARIANT_SUCCESS, { variant: data })
    } catch (e) {
      commit(types.FETCH_ONE_VARIANT_FAILURE)
    }
  },

  async fetchFullVariant ({ commit }, { questionId, id }) {
    try {
      const { data } = await axios.get('/api/admin/variants/' + id);

      commit(types.FETCH_ONE_VARIANT_SUCCESS, { variant: data })
    } catch (e) {
      commit(types.FETCH_ONE_VARIANT_FAILURE)
    }
  },

  addVariant ({ commit }, variant) {
    if (variant) {
      commit(types.ADD_VARIANT_SUCCESS, { variant: variant })
    } else {
      commit(types.ADD_VARIANT_FAILURE)
    }
  },

  updateVariant ({ commit }, variant) {
    if (variant) {
      commit(types.UPDATE_VARIANT_SUCCESS, { variant: variant })
    } else {
      commit(types.UPDATE_VARIANT_FAILURE)
    }
  },

  async removeVariant ({ commit }, { variant }) {
    try {
      const { data } = await axios.delete('/api/admin/variants/' + variant.inner_id);

      commit(types.REMOVE_VARIANT_SUCCESS, { variantId: variant.id })
    } catch (e) {
      commit(types.REMOVE_VARIANT_FAILURE)
    }
  },

  async fetchQuestionVariants ({ commit }, { questionId }) {
    try {
      const { data } = await axios.get('/api/questions/' + questionId + '/variants');
      commit(types.FETCH_QUESTION_VARIANTS_SUCCESS, { questionId: questionId, variants: data })
    } catch (e) {
      commit(types.FETCH_QUESTION_VARIANTS_FAILURE)
    }
  },

  async fetchFullQuestionVariants ({ commit }, { questionId }) {
    try {
      const { data } = await axios.get('/api/admin/questions/' + questionId + '/variants');

      commit(types.FETCH_QUESTION_VARIANTS_SUCCESS, { questionId: questionId, variants: data })
    } catch (e) {
      commit(types.FETCH_QUESTION_VARIANTS_FAILURE)
    }
  },

  // async study ({ commit }, { id }) {
  //   try {
  //     const { data } = await axios.post('/api/user_variants/' + id);
  //
  //     commit(types.STUDY_VARIANT_SUCCESS)
  //   } catch (e) {
  //     commit(types.STUDY_VARIANT_FAILURE)
  //   }
  // },
};
